export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    err403: (state) => state.items.find((err) => err.status === 403),
    err404: (state) => state.items.find((err) => err.status === 404),
  },
  mutations: {
    add(state, payload) { state.items.push(payload); },
    clear(state) { state.items = []; },
  },
  actions: {},
};
